import React from 'react'
import {StyleSheet, View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import {useNavigation} from '@react-navigation/native'

import {usePalette} from '#/lib/hooks/usePalette'
import {type NavigationProp} from '#/lib/routes/types'
import {atoms as a} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {Lock_Stroke2_Corner2_Rounded as LockIcon} from '#/components/icons/Lock'
import {Text} from '#/components/Typography'

export function RoomsPaywall() {
  const pal = usePalette('default')
  const {_} = useLingui()
  const navigation = useNavigation<NavigationProp>()

  const handleJoinPremium = React.useCallback(() => {
    navigation.navigate('Premium')
  }, [navigation])

  return (
    <View style={[styles.container, pal.view]}>
      <LockIcon width={48} height={48} style={pal.text} />
      <Text style={[styles.title, pal.text]}>
        <Trans>Premium Feature</Trans>
      </Text>
      <Text style={[styles.description, pal.textLight]}>
        <Trans>This feature is available to Premium members only.</Trans>
      </Text>
      <Button
        label={_(msg`Join Premium`)}
        onPress={handleJoinPremium}
        size="large"
        variant="solid"
        color="primary"
        style={[a.rounded_md, styles.button]}>
        <ButtonText>
          <Trans>Join Premium</Trans>
        </ButtonText>
      </Button>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    gap: 16,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    textAlign: 'center',
    maxWidth: 300,
  },
  button: {
    marginTop: 8,
  },
})
